<script lang="ts">
    import { connection } from "../lib/connection.svelte.ts";

    let host = $state(window.location.origin);
    let player = $state("");
    let password = $state("");
    let mode = $state<"connect" | "create">("connect");

    async function submit(e: SubmitEvent) {
        e.preventDefault();
        await connection.login(host, player, password, mode);
    }
</script>

<div class="login-wrap">
    <form class="login-form" onsubmit={submit}>
        <div class="wordmark">ARKHAM</div>
        <p class="tagline">That is not dead which cannot lie</p>

        <label>
            <span>Server</span>
            <input type="url" bind:value={host} required spellcheck="false" />
        </label>

        <label>
            <span>Player name</span>
            <input type="text" bind:value={player} required spellcheck="false" autocomplete="username" />
        </label>

        <label>
            <span>Password</span>
            <input type="password" bind:value={password} required autocomplete="current-password" />
        </label>

        <div class="mode-row">
            <label class="radio">
                <input type="radio" bind:group={mode} value="connect" /> Connect
            </label>
            <label class="radio">
                <input type="radio" bind:group={mode} value="create" /> Create account
            </label>
        </div>

        {#if connection.error}
            <p class="error">{connection.error}</p>
        {/if}

        <button type="submit" disabled={connection.status === "connecting"}>
            {connection.status === "connecting" ? "Connecting…" : "Enter"}
        </button>
    </form>
</div>

<style>
    .login-wrap {
        position: fixed;
        inset: 0;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .login-form {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: min(380px, 90vw);
        background: rgba(8, 6, 4, 0.88);
        border: 1px solid rgba(180, 155, 100, 0.2);
        padding: 2.5rem 2rem;
        font-family: 'Courier New', Courier, monospace;
        color: #c5b890;
    }

    .wordmark {
        font-size: 2rem;
        letter-spacing: 0.35em;
        color: #d4c49a;
        text-align: center;
    }

    .tagline {
        text-align: center;
        font-style: italic;
        font-size: 0.8rem;
        color: #7a7060;
        margin-top: -0.5rem;
    }

    label {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        font-size: 0.78rem;
        letter-spacing: 0.06em;
        color: #9a9080;
    }

    input[type="text"],
    input[type="url"],
    input[type="password"] {
        background: rgba(255, 255, 255, 0.04);
        border: 1px solid rgba(180, 155, 100, 0.25);
        color: #d4c49a;
        padding: 0.45em 0.6em;
        font-family: inherit;
        font-size: 0.9rem;
        outline: none;
        transition: border-color 0.15s;
    }

    input:focus {
        border-color: rgba(180, 155, 100, 0.55);
    }

    .mode-row {
        display: flex;
        gap: 1.5rem;
    }

    .radio {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.4rem;
        cursor: pointer;
        color: #9a9080;
        font-size: 0.82rem;
    }

    .error {
        color: #c06060;
        font-size: 0.82rem;
    }

    button {
        background: transparent;
        border: 1px solid rgba(180, 155, 100, 0.4);
        color: #d4c49a;
        padding: 0.55em 1em;
        font-family: inherit;
        font-size: 0.9rem;
        letter-spacing: 0.1em;
        cursor: pointer;
        transition: background 0.15s, border-color 0.15s;
    }

    button:hover:not(:disabled) {
        background: rgba(180, 155, 100, 0.1);
        border-color: rgba(180, 155, 100, 0.65);
    }

    button:disabled {
        opacity: 0.5;
        cursor: default;
    }
</style>
